import { render, staticRenderFns } from "./column-visible-wrapper.vue?vue&type=template&id=2c377180"
import script from "./column-visible-wrapper.vue?vue&type=script&lang=ts"
export * from "./column-visible-wrapper.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports